<template>
    <div class="main index">
        <ul class="tabs" v-if="task_power.power.look">
            <li :class="{tab:true,active:v.route_name===$route.name}" v-for="(v,k) in tab" :key="k"
                @click="tabChange(v.route_name)">{{v.name}}</li>
        </ul>
        <ul class="tabs" v-else>
            <li>我的任务</li>
        </ul>
        <div class="container">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                tab:[
                    {
                        name:'我的任务',
                        route_name:'task_all',
                    },
                    {
                        name:'查询统计',
                        route_name:'task_static',
                    }
                ]
            }
        },
        computed:{
            task_power(){
                return this.$store.state.user.current_user.task_power
            }
        },
        methods:{
            tabChange(name){
                if(name===this.$route.name) return;
                this.$router.replace({name:name})
            }
        }
    }
</script>

<style scoped lang="less">

</style>